import { getErrorMessage } from 'application/util/error.util';

import './general.style.sass';
import template from './general.tpl.pug';

class GeneralSettingsController {
    /* @ngInject */
    constructor($q, profileService, preferenceService, sessionService, modalService, storageService, notificationService) {
        this.$q = $q;
        this.profileService = profileService;
        this.preferenceService = preferenceService;
        this.sessionService = sessionService;
        this.modalService = modalService;
        this.storageService = storageService;
        this.notificationService = notificationService;
    }

    $onInit() {
        this.loading = true;
        this.preferences = {};
        this.selectedTeam = null;

        return this.$q.all([
            this.preferenceService.get(),
            this.sessionService.initialize()
        ]).then(([preferences, session]) => {
            this.preferences = preferences;
            this.selectedTeam = this.getSelectedTeam(session && session.teams);
        }).catch((result) => {
            this.notificationService.showError(getErrorMessage(result, `We were not able to retrieve your general settings.`));
        }).finally(() => {
            this.loading = false;
        });
    }

    getSelectedTeam(teams) {
        const selectedTeamId = +this.storageService.getUserItem('selected-team');
        const availableTeams = teams || [];

        return availableTeams.find((team) => team && team.id === selectedTeamId) || availableTeams[0] || null;
    }

    get autoCategorization() {
        return this.preferences && !this.preferences.autoCategorizationOff;
    }

    set autoCategorization(value) {
        if (this.preferences) {
            this.preferences.autoCategorizationOff = !value;
        }
    }

    updatePreferences() {
        return this.preferenceService.save(this.preferences).catch((result) => {
            this.notificationService.showError(getErrorMessage(result, `We were not able to update your general settings.`));
        });
    }

    manageTransactionsByEmail() {
        if (!this.selectedTeam || !this.selectedTeam.id) {
            return null;
        }

        return this.modalService.open({
            component: 'dbAEmailIngestTokenModal',
            bindings: {
                teamId: this.selectedTeam.id,
                teamName: this.selectedTeam.name
            }
        }).catch(() => null);
    }
}

export default {
    selector: 'dbAGeneralSettings',
    template: template(),
    controller: GeneralSettingsController
};



// WEBPACK FOOTER //
// ./src/application/scene/authorized/scene/settings/scene/general/general.cmpt.js